import { render, staticRenderFns } from "./BulkWizard.vue?vue&type=template&id=6a6806c4&scoped=true&"
import script from "./BulkWizard.vue?vue&type=script&lang=js&"
export * from "./BulkWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6806c4",
  null
  
)

export default component.exports